/* istanbul ignore file */
export * from './SearchResultCategoryFilter';
